import React from 'react';
import { Icon } from '../../elements';
import './cartIcon.scss';

export default () => (
  <div className="cart-toggle-icon">
    <Icon type="basket" />
  </div>
);
